import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { addLocale, replace } from '../../misc';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request, { sof2ApiHost, emergencyFormsUrl } from '../../utils/request';
import { sof2HomeUrl } from '../../utils/constant';

const CategoryForm = ({ formData, locale, history, categoryItemData }) => {
  const {
    manageAccount: { accessControlFormsList }
  } = useLocalizedStringsContext();
  const {
    fields: { name, keyNameToDisable, platform, emergencyFormUrl }
  } = categoryItemData;
  const {
    fields: { name: formName, title, hideOnDashboard }
  } = formData;

  const [isFromFreezeEnabled, setIsFromFreezeEnabled] = useState(false);
  const addLocaleToUrl = addLocale(locale);
  const profile = request.getProfile();
  const formType = _.get(profile, 'formTypes', {
    disableIoT: false,
    disableCallcenter: false,
    disableBusinessApps: false,
    disableBusinessConnect: false
  });
  const isCategoryDisabled =
    _.get(formType, keyNameToDisable, false) || isFromFreezeEnabled;

  if (hideOnDashboard) return null;

  const handleClick = () => {
    if (platform === 'SOF2') {
      window.location.replace(
        request.getSSOLoginState()
          ? `${sof2ApiHost}/users/sso-login?url=${JSON.stringify({
              title,
              name,
              formField: formData.fields
            })}`
          : sof2HomeUrl
      );
    } else if (platform === 'EMERGENCY_FORMS') {
      const accessToken = request.getToken();
      const encodedData = encodeURIComponent(
        JSON.stringify({ token: accessToken, platform: 'sof1' })
      );

      window.open(
        `${emergencyFormsUrl}/${locale}${emergencyFormUrl}?key=${encodedData}`,
        '_blank'
      );
    } else {
      const url = addLocaleToUrl(`/${replace(name)}/${replace(formName)}/`);
      history.push(url);
      history.go();
    }
  };

  useEffect(() => {
    (async () => {
      const currentCategory = accessControlFormsList.filter(
        item => item.key === keyNameToDisable
      );
      if (currentCategory && _.get(currentCategory, '0.formFreezeId', 0)) {
        try {
          const result = await request.get(
            `/options/${_.get(currentCategory, '0.formFreezeId')}`
          );
          if (result && result.status === 200) {
            setIsFromFreezeEnabled(+_.get(result, 'data.value', 0) === 1);
          }
        } catch (err) {
          throw err;
        }
      }
    })();
  }, []);

  return (
    <Button
      variant={{ priority: 'low' }}
      disabled={isCategoryDisabled}
      onPress={handleClick}
    >
      {title}
    </Button>
  );
};

CategoryForm.propTypes = {
  formData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      hideOnDashboard: PropTypes.bool
    })
  }).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }).isRequired,
  categoryItemData: PropTypes.arrayOf(
    PropTypes.shape({
      metadata: PropTypes.shape({}),
      sys: PropTypes.shape({}),
      fields: PropTypes.shape({
        availableFor: PropTypes.arrayOf(PropTypes.string),
        description: PropTypes.shape({
          data: PropTypes.shape({}),
          content: PropTypes.arrayOf(PropTypes.shape({})),
          nodeType: PropTypes.string
        })
      }),
      title: PropTypes.string,
      name: PropTypes.string,
      platform: PropTypes.string,
      forms: PropTypes.arrayOf(PropTypes.shape({})),
      description: PropTypes.shape({
        data: PropTypes.shape({}),
        content: PropTypes.arrayOf(PropTypes.shape({})),
        nodeType: PropTypes.string
      }),
      keyNameToDisable: PropTypes.string.isRequired,
      emergencyFormUrl: PropTypes.string
    })
  ).isRequired
};

export default CategoryForm;
